import React from 'react';
import './style.scss';

export type MarketDescBlockValue =
  | string
  | {
      crossed: string;
      active: string;
    };

interface Props {
  title: string;
  value: MarketDescBlockValue;
  className?: string;
}

const MarketPageDescBlock = ({ title, value, className }: Props) => (
  <div className={className}>
    <p className='caption mb-5'>{title}:</p>
    {typeof value === 'string' ? (
      <h4 className='body-2'>{value}</h4>
    ) : (
      <h4 className='market-page-desc-block-extended-value'>
        <s>{value.crossed}</s>&nbsp;
        <span>{value.active}</span>
      </h4>
    )}
  </div>
);

export default MarketPageDescBlock;
